import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import GridContainer from '../../@jumbo/components/GridContainer';
import generalService from '../../services/f5-services/generalService';

import SimpleDataCard from '../ocurrences/SharedComponents/SimpleDataCard';
import OcurrencesDataRender from '../ocurrences/SharedComponents/OcurrencesDataRender';

import FileCopyIcon from '@material-ui/icons/FileCopy';

const SubdepartmentOcurrences = ({ id }) => {
  const [currentList, setCurrentList] = useState('subdepartament_ocurrences');
  const [subdepartmentData, setSubdepartmentData] = useState(null);

  useEffect(() => {
    const getData = async () => {
      const res = await generalService.getSubdepartmentOcurrences(id);

      setSubdepartmentData(res.caixa);
    };

    getData();
  }, [setSubdepartmentData, id]);

  const ocurrencesData = {
    subdepartament_ocurrences: {
      icon: <FileCopyIcon fontSize="large" />,
      label: 'Recebidas pelo Subdepartamento',
      uniqueIdentifier: 'subdepartament_ocurrences',
      colors: ['#2f6bcc', '#042d80'],
      data: subdepartmentData,
    },
  };

  return (
    <GridContainer>
      <Grid item xs={12} sm={6} md={3}>
        <SimpleDataCard
          label={ocurrencesData.subdepartament_ocurrences.label}
          icon={ocurrencesData.subdepartament_ocurrences.icon}
          colors={ocurrencesData.subdepartament_ocurrences.colors}
          value={ocurrencesData.subdepartament_ocurrences.data ? ocurrencesData.subdepartament_ocurrences.data.length : 0}
          setList={() => setCurrentList('subdepartament_ocurrences')}
        />
      </Grid>
      <Grid item xs={12}>
        <OcurrencesDataRender
          bgcolor={ocurrencesData[currentList].colors[0]}
          data={ocurrencesData[currentList].data}
          label={ocurrencesData[currentList].label}
          icon={ocurrencesData[currentList].icon}
        />
      </Grid>
    </GridContainer>
  );
};

export default SubdepartmentOcurrences;
